// Shared constants for the HELOC landing page
export const APPLY_URL =
  "https://heloc.lightningheloc.com/account/heloc/register?referrer=ac9201d6-2be1-4b0b-92bd-5467e1759ada";

export const BOOK_URL =
  "https://outlook.office.com/bookwithme/user/c3b7fdc1ed6d4156b81efcc4b69ad918@PRMG.NET/meetingtype/5czXUesh00qFmNScnWGkBA2?anonymous&ismsaljsauthenabled&ep=mLinkFromTile";

export const PHONE_NUMBER = "770-851-5403";
export const PHONE_TEL = "tel:+17708515403";
export const LO_NAME = "Randy Wilson";
export const LO_NMLS = "2685815";
export const LO_SITE = "https://www.randywilson.com";
export const LO_SITE_LABEL = "www.randywilson.com";

export const PRMG_NMLS = "75243";
export const PRMG_ADDRESS = "1265 Corona Pointe Court, Suite 301, Corona, CA 92879";

export const HERO_IMAGE =
  "https://images.pexels.com/photos/16631149/pexels-photo-16631149.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const HEADSHOT_IMAGE =
  "https://customer-assets.emergentagent.com/job_heloc-hub/artifacts/0x2u7ksu_Randy%20Color.jpg";
export const PRMG_LOGO =
  "https://customer-assets.emergentagent.com/job_heloc-hub/artifacts/51b4det6_PRMG.png";
export const RENOVATION_IMAGE =
  "https://images.pexels.com/photos/36035073/pexels-photo-36035073.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const FAMILY_IMAGE =
  "https://images.pexels.com/photos/12263245/pexels-photo-12263245.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
